import { NgModule, inject, provideAppInitializer, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCollapse, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { PagePerformanceRunService } from '@client/app/modules/page-performance/run/page-performance.run';
import { PagePerformancePagesModule } from './pages/pages.module';
import { PagePerformanceAuditDisplayBinaryComponent } from './components/display-modes/binary/page-performance-audit-display-binary.component';
import { PagePerformanceAuditDisplayInformativeRequestChainComponent } from './components/display-modes/informative/request-chain/request-chain.component';
import { PagePerformanceAuditDisplayInformativeComponent } from './components/display-modes/informative/page-performance-audit-display-informative.component';
import { PagePerformanceAuditDisplayManualComponent } from './components/display-modes/manual/page-performance-audit-display-manual.component';
import { PagePerformanceAuditDisplayNotApplicableComponent } from './components/display-modes/not-applicable/page-performance-audit-display-not-applicable.component';
import { PagePerformanceAuditDisplayNumericComponent } from './components/display-modes/numeric/page-performance-audit-display-numeric.component';
import { TableScoreChartComponent } from './components/score-chart/table-score-chart.component';
import { FormPagePerformanceConfirmArchiveComponent } from './forms/confirm-archive/confirm-archive.component';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { NgbProgressbar, NgbProgressbarStacked, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@client/app/modules/translate.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import {
    LayoutModule,
    MonChartsModule,
    MonDatePickerModule,
    MonTableSortModule,
} from '@monsido/angular-shared-components';
import { ExportModule } from '@client/app/modules/export/export.module';
import { ComponentsModule } from '@client/app/components/components.module';
import { IconsModule } from '@monsido/ng2/layout/icons/icons.module';
import { MarkdownViewerComponent } from '@client/app/components/markdown-viewer/markdown-viewer.component';
import { MonNumberPipe } from '@client/ng2/core/locale/pipes/mon-number.pipe';
import { PagePerformancePagesComponent } from './pages/domain/pages/pages.component';
import { PipesModule } from '@monsido/core/pipes/pipes.module';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { PagePerformanceDialogsAuditDetailsComponent } from './dialogs/audit-details/audit-details.component';
import { NgCsvDirective } from '@client/app/directives/ng-csv.directive';

export function init_app (pagePerformanceRunService: PagePerformanceRunService) {
    return () => pagePerformanceRunService.initializeApp();
}

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        PagePerformancePagesModule,
        CommonModule,
        FormsModule,
        NgbProgressbarStacked,
        NgbProgressbar,
        NgbTooltip,
        NgbTooltipModule,
        TranslateModule,
        UpgradePipeModule,
        MonChartsModule,
        LineComponent,
        ExportModule,
        ComponentsModule,
        IconsModule,
        MonTableSortModule,
        LayoutModule,
        MonDatePickerModule,
        MarkdownViewerComponent,
        MonNumberPipe,
        PipesModule,
        MonActionMenuModule,
        NgbCollapse,
        NgCsvDirective,
    ],
    declarations: [
        PagePerformanceAuditDisplayBinaryComponent,
        PagePerformanceAuditDisplayInformativeRequestChainComponent,
        PagePerformanceAuditDisplayInformativeComponent,
        PagePerformanceAuditDisplayManualComponent,
        PagePerformanceAuditDisplayNotApplicableComponent,
        PagePerformanceAuditDisplayNumericComponent,
        TableScoreChartComponent,
        FormPagePerformanceConfirmArchiveComponent,
        PagePerformancePagesComponent,
        PagePerformanceDialogsAuditDetailsComponent,
    ],
    providers: [
        provideAppInitializer(() => {
            const initializerFn = (init_app)(inject(PagePerformanceRunService));
            return initializerFn();
        })],
})
export class PagePerformanceModule { }
